import { render } from "./FooterView.vue?vue&type=template&id=3c3df850"
import script from "@/assets/js/footer.js?vue&type=script&lang=js&external"
export * from "@/assets/js/footer.js?vue&type=script&lang=js&external"

import "./FooterView.vue?vue&type=style&index=0&id=3c3df850&scopped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__